import omit from 'lodash/omit'
import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { decamelizeKeysWithNumbers } from 'utils/api/decamelizeKeysWithNumbers'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { TAB } from 'apps/fleet-planner/constants/loads'
import { ILoadsParams, ILoad } from 'apps/fleet-planner/types/loads'

export const FETCH_LOADS_ACTION_TYPES = generateApiActionTypes('FETCH_LOADS')
export const fetchLoads = (params: ILoadsParams, isFleet?: boolean) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: isFleet ? FP_ENDPOINTS.fleet : FP_ENDPOINTS.loads,
      method: 'GET',
      params,
    },
    actionTypes: Object.keys(FETCH_LOADS_ACTION_TYPES),
    isFleet,
  },
  type: '',
})

export const CREATE_LOAD_ACTION_TYPES = generateApiActionTypes('CREATE_LOAD')
export const createLoad = (params: ILoad) => {
  const truckId = params.truck?.id
  const trailerId = params.trailer?.id
  const equipmentNumbers = {
    ...(trailerId && { trailerId }),
    ...(truckId && { truckId }),
  }
  const newParams = omit({ ...params, ...equipmentNumbers }, ['truck', 'trailer'])
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: FP_ENDPOINTS.loads,
        method: 'POST',
        body: decamelizeKeysWithNumbers({ shipment: { entityId: 4, ...newParams } }),
      },
      actionTypes: Object.keys(CREATE_LOAD_ACTION_TYPES),
    },
  }
}

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const setActiveTab = (tab: TAB) => ({
  type: SET_ACTIVE_TAB,
  payload: { tab },
})

export const SET_LAST_CREATED_LOAD = 'SET_LAST_CREATED_LOAD'
export const setLastCreatedLoad = (load: ILoad) => ({
  type: SET_LAST_CREATED_LOAD,
  payload: { load },
})
